"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const locations = [{
  name: "San Francisco County",
  path: "#"
}, {
  name: "Santa Clara County",
  path: "#"
}, {
  name: "Santa Cruz County",
  path: "#"
}, {
  name: "Monterey County",
  path: "#"
}, {
  name: "San Francisco",
  path: "#"
}, {
  name: "San Jose",
  path: "#"
}, {
  name: "Palo Alto",
  path: "#"
}, {
  name: "Sunnyvale",
  path: "#"
}, {
  name: "Mountain View",
  path: "#"
}, {
  name: "Los Gatos",
  path: "#"
}, {
  name: "Morgan Hill",
  path: "#"
}, {
  name: "Gilroy",
  path: "#"
}, {
  name: "Cupertino",
  path: "#"
}, {
  name: "Campbell",
  path: "#"
}, {
  name: "Saratoga",
  path: "#"
}, {
  name: "Milpitas",
  path: "#"
}, {
  name: "Los Altos",
  path: "#"
}, {
  name: "Santa Cruz",
  path: "#"
}, {
  name: "Capitola",
  path: "#"
}, {
  name: "Scotts Valley",
  path: "#"
}, {
  name: "Watsonville",
  path: "#"
}, {
  name: "Monterey",
  path: "#"
}, {
  name: "Carmel-by-the-Sea",
  path: "#"
}, {
  name: "Pacific Grove",
  path: "#"
}, {
  name: "Marina",
  path: "#"
}, {
  name: "Seaside",
  path: "#"
}, {
  name: "Salinas",
  path: "#"
}];
export default function AreaCoverageList() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="179260" id="service-areas" className="bg-background text-foreground py-16 md:py-24 border-t border-border">
      <div ref={ref} className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground font-default tracking-tight">
            California Deck Builders: Our Service Areas
          </h2>
          <p className="mt-4 text-muted-foreground font-sans max-w-2xl mx-auto">
            PCH Builders has been the trusted name in deck construction across Northern California since 1990. We provide expert installation for families in these coastal and inland communities.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-y-4 gap-x-8 md:gap-y-6">
          {locations.map((location, i) => <div key={location.name} data-index={i} className="col-span-1 md:col-span-6 flex items-center border-b border-border/50 pb-2 md:border-none md:pb-0">
              <Link to={location.path} className="group relative inline-flex items-center text-lg font-medium text-foreground font-sans py-1 transition-colors hover:text-ring/90">
                {location.name}
                <span className="absolute bottom-0 left-0 h-[2px] w-full origin-bottom-right scale-x-0 bg-ring transition-transform duration-300 ease-out group-hover:origin-bottom-left group-hover:scale-x-100" />
              </Link>
            </div>)}
        </div>
      </div>
    </section>;
}